/** Every priority tag, in the order a row shows them. Ids, not labels: the cell and the export translate them. */
export const PRIORITY_TAGS = ['corpCompanyPaid', 'corpMemberPaid', 'healthChampion', 'suspended'] as const;

export type PriorityTag = (typeof PRIORITY_TAGS)[number];

/** The member fields the tags are derived from. */
export interface PriorityTagSource {
  /** Who pays a corporate membership. Null for a member who isn't on a corporate account at all. */
  billToNationalAccount: boolean | null;
  isHealthChampion: boolean;
  memberStatus: string | null;
}

/**
 * A member's priority tags. A corporate member is tagged by who pays — the company or the member —
 * and a non-corporate one not at all; Health Champion and Suspended stand on their own.
 */
export function priorityTags({
  billToNationalAccount,
  isHealthChampion,
  memberStatus,
}: PriorityTagSource): PriorityTag[] {
  const tags: PriorityTag[] = [];
  if (billToNationalAccount === true) tags.push('corpCompanyPaid');
  if (billToNationalAccount === false) tags.push('corpMemberPaid');
  if (isHealthChampion) tags.push('healthChampion');
  if (memberStatus === 'Suspended') tags.push('suspended');
  return tags;
}
